<template>
  <div class="body">
    <div style="padding-top:40px" align="center">
      <el-row>
        <div style="
          font-family: 'Roboto Serif',serif;
          font-weight: 600;
          font-size: 24px;
          line-height: 28px;
          color:#3E6161;">How to get started?</div>
      </el-row>
    </div>
    <div style="padding-top:30px">
      <el-collapse accordion style="padding-bottom:56px">
        <el-collapse-item>
          <template slot="title">
            <!-- <span class="material-icons-outlined" style="color:#3E6161">
              radio_button_unchecked
            </span> -->
            <div class="roboto">Schedule a Demo</div>
          </template>
          <div class="nroboto">During your demo, you will learn the ins and outs of the ZHR from our EHR Manager.</div>
          <img src="../../assets/mobile/tostart/start1.svg" alt="" class="">
        </el-collapse-item>
        <el-collapse-item>
          <template slot="title">

            <div class="roboto">Create an Account</div>
          </template>
          <div class="nroboto">When you decide the ZHR is right for you, you will set up your account.</div>
          <img src="../../assets/mobile/tostart/start2.svg" alt="" class="">
        </el-collapse-item>
        <el-collapse-item title="B">
          <template slot="title">

            <div class="roboto">Buile your EHR</div>
          </template>
          <div class="nroboto">Now that your account is set up, we will transfer your data into the ZHR.</div>
          <img src="../../assets/mobile/tostart/start3.svg" alt="" class="">
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        activeName: '1'
      };
    }
  }
</script>

<style scoped>
.body{
  padding-left: 27px;
  padding-right: 27px;
}
.roboto{
  color:#3E6161;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 21px;
}
.nroboto{
  color:#3E6161;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
}
  </style>
